export default "__VITE_ASSET__480e8353__"